import { useSSFBehaviors } from 'hooks';
import { SSFBehaviorsContextType } from 'hooks/useSSFBehaviors/useSSFBehaviors.types';
import { fetchCommunitiesConfig } from 'pages/SettingsPage/PositionsSettingsPage/B2BPositionsSettingsPage/modals/PositionsByLocation/PositionsAllocationModal.constants';
import { FC, useContext, useMemo } from 'react';
import { FetchCommunitiesQuery } from 'types/graphql';
import { createGQLDataContext } from 'utils/createDataContext';

interface IFetchCommunitiesList {}

export const FetchCommunitiesListContext = createGQLDataContext<IFetchCommunitiesList>({});

export const FetchCommunitiesListProvider: FC = ({ children }) => {
  const [values, rest] = useSSFBehaviors(fetchCommunitiesConfig());

  const contextValue = useMemo(
    () => ({ values, hasNextPage: !!rest?.data?.fetchCommunities?.pageInfo?.hasNextPage, ...rest }),
    [rest, values],
  );
  return (
    <FetchCommunitiesListContext.Provider value={contextValue}>
      {children}
    </FetchCommunitiesListContext.Provider>
  );
};

export const useFetchCommunitiesListContext = (): SSFBehaviorsContextType<FetchCommunitiesQuery> & {
  hasNextPage: boolean;
} => useContext(FetchCommunitiesListContext);
